import {
  AdvFluidComponent, ContactUsSectionComponent, FeaturedGuidesSectionComponent, FeaturedNewsSectionComponent,
  TrustpilotSectionComponent,
} from '../../../domain/graphcms';
import AdvFluidAdapter, { AdvFluidAdapterProps } from '../adv-fluid-adapter/AdvFluidAdapter';
import ContactUsSection, { ContactUsSectionProps } from '../contact-us-section/ContactUsSection';
import FeaturesGuidesWidget, { FeaturesGuidesWidgetProps } from '../featured-guides-widget/FeaturesGuidesWidget';
import FeaturesNewsWidget, { FeaturesNewsWidgetProps } from '../featured-news-widget/FeaturesNewsWidget';
import TrustpilotSection, { TrustpilotSectionProps } from '../trustpilot-section/TrustpilotSection';
import { CMSComponentsToWidgets } from './types';

export function toAdvFluidProps(data: AdvFluidComponent): AdvFluidAdapterProps {
  return {
    advFluidType: data.advFluid.type,
    variant: data.advFluid.variant,
  };
}

export function toFeaturedGuidesWidgetProps(data: FeaturedGuidesSectionComponent): FeaturesGuidesWidgetProps {
  return {
    title: data.title.markdown,
    guides: data.guides,
  };
}

export function toFeaturedNewsWidgetProps(data: FeaturedNewsSectionComponent): FeaturesNewsWidgetProps {
  return {
    title: data.title.markdown,
    news: data.news,
  };
}

export function toContactUsSectionProps(data: ContactUsSectionComponent): ContactUsSectionProps {
  return {
    title: data.title.markdown,
    content: data.content?.markdown,
    formTitle: data.formTitle.markdown,
  };
}

export function toTrustpilotSectionProps(data: TrustpilotSectionComponent & { isLanding?: boolean }): TrustpilotSectionProps {
  return {
    title: data.title.markdown,
    content: data.content?.markdown,
    type: data.trustpilotWidgetType,
    theme: data.trustpilotWidgetTheme,
    clickable: !data.isLanding,
  };
}

export const widgetComponentsMapper: CMSComponentsToWidgets = {
  AdvFluidComponent: {
    name: 'AdvFluid',
    component: AdvFluidAdapter,
    toProps: toAdvFluidProps,
  },
  FeaturedGuidesSectionComponent: {
    name: 'FeaturesGuidesWidget',
    component: FeaturesGuidesWidget,
    toProps: toFeaturedGuidesWidgetProps,
  },
  FeaturedNewsSectionComponent: {
    name: 'FeaturesNewsWidget',
    component: FeaturesNewsWidget,
    toProps: toFeaturedNewsWidgetProps,
  },
  ContactUsSectionComponent: {
    name: 'ContactUsWidget',
    component: ContactUsSection,
    toProps: toContactUsSectionProps,
  },
  TrustpilotSectionComponent: {
    name: 'TrustpilotSection',
    component: TrustpilotSection,
    toProps: toTrustpilotSectionProps,
  },
};
